import { Link, useNavigate } from 'react-router-dom';
import { Search, ShoppingBag, User, Heart, Menu } from 'lucide-react';
import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useCart } from '../contexts/CartContext';
import { useData } from '../contexts/DataContext';

export default function Header() {
  const navigate = useNavigate();
  const { isAuthenticated, user, isCourier, isAdmin } = useAuth();
  const { getCartCount } = useCart();
  const { categories } = useData();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const cartCount = getCartCount();

  // DEBUG: Log categories to verify no duplicates
  console.log('🔍 Header categories:', categories.length, categories.map(c => c.name));
  console.log('🔐 Header auth isAuthenticated=', isAuthenticated, 'isCourier=', isCourier, 'isAdmin=', isAdmin);

  return (
    <>
      {/* Top Bar - Removed as requested */}

      <div className="bg-trendyol-orange text-white py-2 overflow-hidden">
        <div className="animate-marquee whitespace-nowrap inline-block">
          <span className="mx-8 text-sm font-medium">🎉 ÜCRETSİZ KARGO - 150 TL ÜZERİ TÜM SİPARİŞLERDE</span>
          <span className="mx-8 text-sm font-medium">⚡ AYNI GÜN TESLİMAT - SEÇİLİ ÜRÜNLERDE</span>
          <span className="mx-8 text-sm font-medium">💰 KARGO BEDAVA - TÜM TÜRKİYE'YE</span>
          <span className="mx-8 text-sm font-medium">🎉 ÜCRETSİZ KARGO - 150 TL ÜZERİ TÜM SİPARİŞLERDE</span>
          <span className="mx-8 text-sm font-medium">⚡ AYNI GÜN TESLİMAT - SEÇİLİ ÜRÜNLERDE</span>
          <span className="mx-8 text-sm font-medium">💰 KARGO BEDAVA - TÜM TÜRKİYE'YE</span>
        </div>
      </div>

      <header
        className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm"
        data-testid="main-header"
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex items-center justify-between h-16 md:h-20">
            <button
              className="lg:hidden p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              data-testid="mobile-menu-toggle"
            >
              <Menu className="w-6 h-6" />
            </button>

            <Link
              to="/"
              className="font-manrope font-bold text-2xl md:text-3xl text-trendyol-orange"
              data-testid="logo-link"
            >
              Alışveriş Burada
            </Link>

            <div className="hidden lg:flex flex-1 max-w-2xl mx-8">
              <div className="relative w-full">
                <input
                  type="text"
                  placeholder="Aradığınız ürün, kategori veya markayı yazınız"
                  className="w-full h-12 pl-4 pr-12 border-2 border-gray-200 rounded-lg focus:border-trendyol-orange focus:outline-none transition-colors"
                  data-testid="search-input"
                />
                <button
                  className="absolute right-2 top-1/2 -translate-y-1/2 bg-trendyol-orange text-white p-2 rounded-md hover:bg-orange-600 transition-colors"
                  data-testid="search-button"
                >
                  <Search className="w-5 h-5" />
                </button>
              </div>
            </div>

            <div className="flex items-center gap-2 md:gap-6">
              <button
                onClick={() => navigate(isAuthenticated ? '/hesabim' : '/giris')}
                className="flex items-center gap-1 md:gap-2 hover:text-trendyol-orange transition-colors"
                data-testid="account-button"
              >
                <User className="w-5 h-5" />
                <span className="hidden sm:block text-sm font-medium">
                  {isAuthenticated ? user?.name?.split(' ')[0] || 'Hesabım' : 'Giriş Yap'}
                </span>
              </button>
              <button
                onClick={() => navigate('/favorilerim')}
                className="hover:text-trendyol-orange transition-colors"
                data-testid="favorites-button"
              >
                <Heart className="w-5 h-5" />
              </button>
              <button
                onClick={() => navigate('/sepetim')}
                className="flex items-center gap-2 hover:text-trendyol-orange transition-colors relative"
                data-testid="cart-button"
              >
                <ShoppingBag className="w-5 h-5" />
                {cartCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-trendyol-orange text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-medium">
                    {cartCount}
                  </span>
                )}
              </button>
            </div>
          </div>

          <div className="lg:hidden pb-3">
            <div className="relative">
              <input
                type="text"
                placeholder="Ara"
                className="w-full h-10 pl-4 pr-12 border-2 border-gray-200 rounded-lg focus:border-trendyol-orange focus:outline-none transition-colors"
                data-testid="mobile-search-input"
              />
              <button className="absolute right-2 top-1/2 -translate-y-1/2 bg-trendyol-orange text-white p-1.5 rounded-md">
                <Search className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>

        <nav
          className="hidden lg:block border-t border-gray-100 bg-white"
          data-testid="desktop-nav"
        >
          <div className="max-w-7xl mx-auto px-8">
            <div className="flex items-center gap-6 h-12 overflow-x-auto scrollbar-hide">
              {categories.map((category) => (
                <Link
                  key={category.id}
                  to={`/kategori/${category.slug}`}
                  className="text-sm font-medium text-gray-700 hover:text-trendyol-orange transition-colors whitespace-nowrap"
                  data-testid={`category-link-${category.slug}`}
                >
                  {category.name}
                </Link>
              ))}
            </div>
          </div>
        </nav>
      </header>

      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-[60] lg:hidden"
          onClick={() => setIsMenuOpen(false)}
          data-testid="mobile-menu-overlay"
        >
          <div
            className="absolute left-0 top-0 bottom-0 w-80 bg-white p-6 overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
            data-testid="mobile-menu"
          >
            <h3 className="font-manrope font-bold text-xl mb-6">Kategoriler</h3>
            <div className="space-y-4">
              {categories.map((category) => (
                <Link
                  key={category.id}
                  to={`/kategori/${category.slug}`}
                  className="flex items-center gap-3 text-gray-700 hover:text-trendyol-orange transition-colors"
                  onClick={() => setIsMenuOpen(false)}
                  data-testid={`mobile-category-link-${category.slug}`}
                >
                  <span className="text-2xl">{category.icon}</span>
                  <span className="font-medium">{category.name}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
